import { ASSETS } from "@/assets";
import { DISCORD_URL } from "@/constants/links";

const QUICK = [
  { label: "Vytvořit účet", testid: "footer-create" },
  { label: "Jak hrát", testid: "footer-howto" },
  { label: "Pravidla", testid: "footer-rules" },
  { label: "Lore & Wiki", testid: "footer-lore" },
  { label: "Ke stažení", testid: "footer-download" },
  { label: "Stav serveru", testid: "footer-status" },
];

const SUPPORT = [
  { label: "FAQ", testid: "footer-faq" },
  { label: "Tikety", testid: "footer-tickets" },
  { label: "Nahlásit hráče", testid: "footer-report" },
  { label: "Changelog", testid: "footer-changelog" },
  { label: "Ochrana soukromí", testid: "footer-privacy" },
  { label: "Podmínky služby", testid: "footer-terms" },
];

const Brand = () => (
  <div className="flex items-center">
    <img src={ASSETS.logo} alt="Draconia RP" className="h-[60px] w-auto" />
  </div>
);

const Col = ({ title, links }) => (
  <div>
    <h4 className="mb-5 font-display text-xs font-600 uppercase tracking-[0.24em] text-[#F0801F]">
      {title}
    </h4>
    <ul className="space-y-3">
      {links.map((l) => (
        <li key={l.label}>
          <button
            data-testid={l.testid}
            className="text-sm text-white/55 transition-colors hover:text-white"
          >
            {l.label}
          </button>
        </li>
      ))}
    </ul>
  </div>
);

export const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-[#121215] px-6 pt-16 pb-8" data-testid="footer">
      <div className="mx-auto max-w-[1584px]">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Brand />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/50">
              Bezplatný roleplay server na WoW 3.3.5a, zasazený do Forgotten
              Realms a poháněný D&D 5E.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[
                { i: "fa-brands fa-discord", id: "footer-social-discord", href: DISCORD_URL },
                { i: "fa-brands fa-youtube", id: "footer-social-youtube" },
                { i: "fa-brands fa-twitter", id: "footer-social-twitter" },
              ].map((s) => {
                const className =
                  "grid h-9 w-9 place-items-center rounded-md border border-white/10 text-white/55 transition-colors hover:border-[#F0801F]/40 hover:text-[#F0801F]";
                return s.href ? (
                  <a
                    key={s.id}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={s.id}
                    aria-label="social"
                    className={className}
                  >
                    <i className={s.i} />
                  </a>
                ) : (
                  <button key={s.id} data-testid={s.id} aria-label="social" className={className}>
                    <i className={s.i} />
                  </button>
                );
              })}
            </div>
          </div>

          <Col title="Rychlé odkazy" links={QUICK} />
          <Col title="Podpora" links={SUPPORT} />

          {/* Server status card */}
          <div className="rounded-xl border border-white/10 bg-[#17171b] p-6">
            <h4 className="mb-4 font-display text-xs font-600 uppercase tracking-[0.24em] text-[#F0801F]">
              Stav serveru
            </h4>
            <p className="flex items-center gap-2 font-display text-sm uppercase tracking-[0.12em] text-[#4ade80]">
              <span className="h-2 w-2 rounded-full bg-[#4ade80] shadow-[0_0_8px_#4ade80]" />
              Online
            </p>
            <p className="mt-3 text-sm text-white/55">289 registrovaných účtů</p>
            <p className="text-sm text-white/55">Patch 3.3.5a</p>
            <button
              data-testid="footer-check-status-btn"
              className="mt-5 w-full rounded-md border border-white/20 py-2.5 font-display text-xs font-600 uppercase tracking-[0.14em] text-white transition-colors hover:border-[#F0801F] hover:text-[#F0801F]"
            >
              Zkontrolovat stav
            </button>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-6 text-center">
          <p className="text-xs text-white/35">
            © {new Date().getFullYear()} Draconia RP. Tento projekt není spojen s
            Blizzard Entertainment, Wizards of the Coast ani Hasbro.
          </p>
        </div>
      </div>
    </footer>
  );
};
